import { render } from "./header-btn.vue?vue&type=template&id=5b5678ae"
const script = {}

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/module-example/pages/page-2/components/header-btn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b5678ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b5678ae', __exports__)) {
    console.log('reload')
    api.reload('5b5678ae', __exports__)
  }
  
  module.hot.accept("./header-btn.vue?vue&type=template&id=5b5678ae", () => {
    console.log('re-render')
    api.rerender('5b5678ae', render)
  })

}


export default __exports__